<template>
	<div class="fuel container-fluid py-3 px-0">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12">
						<h5>SUMMARY PL UNIT {{ this.areatitle }} {{ this.monthname }} {{ this.year }}</h5>
					</div>
				</div>
				<hr class="p-0 m-0" v-if="false">

				<div class="row">
					<div class="col-md-12">
						<el-form  class="mt-2 demo-dynamic" label-position="top" label-width="100px" :inline="true">

							<el-form-item label="">
								<el-select v-model="year" filterable placeholder="Select Year" size="medium">
									<el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="">
								<el-select v-model="month" filterable placeholder="Select Month" size="medium">
									<el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-radio-group v-model="salesarea" size="medium">
									<el-radio label="" border>Konsol</el-radio>
									<el-radio label="Sales Area I" border>SA 1</el-radio>
									<el-radio label="Sales Area II" border>SA 2</el-radio>
									<el-radio label="Sales Area III" border>SA 3</el-radio>
									<el-radio label="Sales Area IV" border>SA 4</el-radio>
									<el-radio label="Sales Area V" border>SA 5</el-radio>
								</el-radio-group>
							</el-form-item>

							<el-form-item v-if="false">
								<el-button size="medium" :loading="loading.table" @click="applyFilter">Konsol</el-button>
							</el-form-item>

						</el-form>
					</div>
				</div>

				<div class="row mt-3">
					<div class="col-md-3 mb-4">
						<ChartView :title="'Laba Rugi'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartRevenueFuelNonFuel :title="'Revenue Fuel Non Fuel'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartVolumePerProduk :title="'Volume Per Produk'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartRevenueNonFuel :title="'Revenue Non Fuel'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea"/>
					</div>
					<!--
					<div class="col-md-4 mb-4">
						<PiechartOutstandingCardview :title="'DELIVERED (YTD)'" :status="'Delivered'" :charttypedefault="'piechart'"/>
					</div>
					-->

				</div>

				<div class="row">
					<div class="col-md-3 mb-4" v-if="salesarea == '' ">
						<ChartLabaRugiPerSalesArea :title="'Laba Bersih Per SA'" :charttypedefault="'barchart'" :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-3 mb-4" v-else>
						<LineChartFuelNonFuelSalesArea :title="'Sales Fuel & Non Fuel SA'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-3 mb-4">
						<ChartLossesPerProduk :title="'Losses Per Produk'" :charttypedefault="'barchart'" :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-3 mb-4">
						<ChartVolumePerProduk :title="'Volume Per Produk'" :charttypedefault="'barchart'" :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartOperatingExpense :title="'Operating Expenses'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartJumlahUnitOperasi :title="'Jumlah Unit Operasi'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea"/>
					</div>
				</div>


				<div class="row">
					<div class="col-md-6 mb-4">
						<EbitdaTopFive :year="year" :month="month" :area="salesarea"/>
					</div>

					<div class="col-md-6 mb-4">
						<EbitdaBottomFive :year="year" :month="month" :area="salesarea"/>
					</div>
				</div>

			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'

import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import DOOutstandingAllStatusByArea from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingAllStatusByArea.vue'
import PiechartOutstandingCardview from '@/views/pages/Fuel/DOOutstanding/Component/PiechartOutstandingCardview.vue'
import DOOutstandingAllDeliveredStatusByArea from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingAllDeliveredStatusByArea.vue'

import ChartView from '@/views/pages/Finance/PLUnit/Component/ChartView.vue'
import ChartLabaRugiPerSalesArea from '@/views/pages/Finance/PLUnit/Component/ChartLabaRugiPerSalesArea.vue'
import ChartLossesPerProduk from '@/views/pages/Finance/PLUnit/Component/ChartLossesPerProduk.vue'
import ChartVolumePerProduk from '@/views/pages/Finance/PLUnit/Component/ChartVolumePerProduk.vue'

import PiechartRevenueFuelNonFuel from '@/views/pages/Finance/PLUnit/Component/PiechartRevenueFuelNonFuel.vue'
import PiechartVolumePerProduk from '@/views/pages/Finance/PLUnit/Component/PiechartVolumePerProduk.vue'
import PiechartOperatingExpense from '@/views/pages/Finance/PLUnit/Component/PiechartOperatingExpense.vue'
import PiechartRevenueNonFuel from '@/views/pages/Finance/PLUnit/Component/PiechartRevenueNonFuel.vue'
import PiechartJumlahUnitOperasi from '@/views/pages/Finance/PLUnit/Component/PiechartJumlahUnitOperasi.vue'

import EbitdaTopFive from '@/views/pages/Finance/PLUnit/Component/EbitdaTopFive.vue'
import EbitdaBottomFive from '@/views/pages/Finance/PLUnit/Component/EbitdaBottomFive.vue'

import LineChartFuelNonFuelSalesArea from '@/views/pages/Finance/PLUnit/Component/LineChartFuelNonFuelSalesArea.vue'

export default{
	extends: Fuel,
	components:{
		//PiechartOutstandingCardview,
		//DOOutstandingAllStatusByArea,
		//DOOutstandingAllDeliveredStatusByArea,
		//PieChart,
		ChartView,
		PiechartRevenueFuelNonFuel,
		PiechartVolumePerProduk,
		PiechartOperatingExpense,
		PiechartRevenueNonFuel,
		PiechartJumlahUnitOperasi,

		ChartLabaRugiPerSalesArea,
		ChartLossesPerProduk,
		ChartVolumePerProduk,

		LineChartFuelNonFuelSalesArea,

		EbitdaTopFive,
		EbitdaBottomFive,
		Footer
	},
	data() {
		return {
            value: 0,
			isChildRoute: false,
			areatitle : '',
			monthname : '',

			salesarea: '',
			month: '', //Penanggalan().bulan,
            year: Penanggalan().tahun,

			options: {
                months:[
                    {value:'', name: 'All/Ytd'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],
            },

			loading: {
				table : false,
			}

		}
	},
	watch: {
		$route(to, from) {
            this.hideNonChildren();
        },

		salesarea() {
			if(this.salesarea == '')
				this.areatitle = 'KONSOL';
			else
				this.areatitle = this.salesarea.toString().toUpperCase();
		},
		month() {
			if(this.month == '')
				this.monthname = 'YTD';
			else
				this.monthname = this.getShortMonthName(this.month).toString().toUpperCase();
		}
	},
	computed: {

	},

    mounted() {
        this.$emit('childrenRoute');
		this.hideNonChildren();
    },
    methods:{
		hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/finance/pl-unit';
        },
	}
}
</script>


<style>

</style>
